import { gql } from "@apollo/client";

const GENERATE_SHOWING_TIME_LISTING_CONFIGURATION_URL = gql`
  query generateShowingTimeListingConfigurationUrl($saleId: ID!) {
    generate_showing_time_listing_configuration_url(sale_id: $saleId) {
      url
    }
  }
`;

export default GENERATE_SHOWING_TIME_LISTING_CONFIGURATION_URL;
